/**
 * Fetches items in cart.
 *
 * @param {*} tradeinUuid
 * @returns the items in cart
 */

async function fetchItemsInCart() {
  const urlParams = new URLSearchParams(window.location.search);
  const tradeinUuid = urlParams.get('tradeinuuid');
  if (tradeinUuid) {
    const tradein = await getTradein(tradeinUuid);
    return tradein.tradeinItems || [];
  }

  return [];
}

async function renderTradeinEstimate() {
  const itemsInCart = await fetchItemsInCart();
  const shippingEstimate = await getShippingEstimate(global.partnerUuid);
  const potentialCreditEl = document.querySelector('.trade-in-confirmation__item-list .trade-in-credit-estimate');
  const estimatedShippingEl = document.querySelector('.trade-in-confirmation__item-list .trade-in-shipping-estimate');
  const estimateGiftcardEl = document.querySelector('.trade-in-confirmation__item-list .trade-in-giftcard-estimate');
  const {
    potentialCreditLow,
    potentialCreditHigh,
  } = calculatePotentialCredit(itemsInCart);
  const { giftcardEstimateLow, giftcardEstimateHigh } = calculateGiftcardEstimate({
    potentialCreditLow,
    potentialCreditHigh,
    shippingEstimate,
  });
  if (potentialCreditEl) setPrice(potentialCreditEl, [potentialCreditLow, potentialCreditHigh]);
  if (estimatedShippingEl) setShippingPrice(estimatedShippingEl, shippingEstimate);
  if (estimateGiftcardEl) setPrice(estimateGiftcardEl, [giftcardEstimateLow, giftcardEstimateHigh]);
}

renderTradeinEstimate();

const packingButton = document.querySelector('.trade-in-confirmation__reprint-packing');
const shippingButton = document.querySelector('.trade-in-confirmation__reprint-shipping');
async function renderTradeInConfirmation() {
  const urlParams = new URLSearchParams(window.location.search);
  const tradeinUuid = urlParams.get('tradeinuuid');
  const tradeInData = await getTradein(tradeinUuid);
  if (!tradeInData && !Shopify.designMode) {
    window.location.href = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-cart`);
    return;
  }

  const { uuid, tradeinItems } = tradeInData;
  const tradeInNumberText = document.createTextNode(`TN-${getUuidPrefix(uuid).toUpperCase()}`);
  document.querySelector('.trade-in-number').appendChild(tradeInNumberText);

  const tradeInItemList = document.querySelector('trade-in-item-list');
  tradeInItemList.renderTradeInItems(tradeinItems);

  const tradeinCartIcon = document.querySelector('trade-in-cart-icon-bubble');
  tradeinCartIcon.setCount(0); //resets trade in items in bag count

  if (tradeInData.trackingNumber) {
    shippingButton.classList.remove('hidden');
  }
}

async function renderTracker() {
  const tracker = document.querySelector('.trade-in-confirmation__tracker ol');
  tracker.classList.add("trade-in-confirmation__tracker-list");

  const list = tracker?.children || [];

  if (list?.length === 0 ) {
    return null;
  }
  for (let i = 0; i < list.length; i++) {
    if (list[i].tagName === 'LI') {
      let circle = document.createElement('div');
      let iconCheck = document.createElement('span');
      iconCheck.classList.add("icon-check");
      circle.appendChild(iconCheck)
      circle.classList.add("circle");
      list[i].appendChild(circle);
      list[i].classList.add("trade-in-confirmation__tracker-step");
    }
  }
}

renderTracker();

renderTradeInConfirmation();

function getUuidPrefix(uuid) {
  let uuidPrefix = ""
  for(let character of uuid) {
    if (character === "-") break;
    uuidPrefix += character
  }
  return uuidPrefix;
}

packingButton.addEventListener('click', async function () {
  const spinner = document.querySelector('.packing-slip__spinner');
  packingButton.style.display = 'none';
  spinner.style.display = 'block';
  const urlParams = new URLSearchParams(window.location.search);
  const tradeinUuid = urlParams.get('tradeinuuid');
  const url = await generatePackingSlip(tradeinUuid);
  window.open(url, '_blank');
  packingButton.style.display = 'block';
  spinner.style.display = 'none';
});
shippingButton.addEventListener('click', async function () {
  const urlParams = new URLSearchParams(window.location.search);
  const tradeinUuid = urlParams.get('tradeinuuid');
  const url = await generateShippingLabel(tradeinUuid);
  window.open(url, '_blank');
});
